export default __webpack_public_path__ + "static/media/VioletLovelace.781746b9.png";